<template>
  <div class="renglonaje-seller__container">
    <v-container fluid class="white page__container--padding py-5">
      <div class="d-flex align-center gap-2 mb-5">
        <div class="outlined-card p-1">
          <icon-title text="RENGLONAJE POR CLIENTE" icon="mdi-clock-outline" />
        </div>
      </div>

      <div class="row disabled-option">
        <div class="col-12">
          <div class="d-flex align-items-center position-relative options">
            <div
              v-if="['Manager', 'Regional'].includes($route.meta.role)"
              class="d-flex align-items-center"
            >
              <b
                >{{
                  $route.meta.role === 'Manager'
                    ? 'Zona'
                    : 'Gerentes de la dirección'
                }}:</b
              >
              <v-select
                v-model="selectedZone"
                :items="zoneSelect"
                dense
                solo
                hide-details
                class="ml-2 max-wx-250"
              />

              <div
                v-if="selectedZone && $route.meta.role === 'Regional'"
                class="d-flex align-items-center ml-4"
              >
                <b>Zona:</b>
                <v-select
                  v-model="selectedManagmentZone"
                  :items="managmentZoneSelect"
                  dense
                  solo
                  hide-details
                  class="ml-2 max-wx-250"
                />
              </div>
            </div>

            <div
              class="position-absolute start-50 translate-middle-x d-flex align-items-center"
            >
              <span class="mr-3">Ver:</span>
              <div class="form-check mb-0 mr-3" style="min-height: 0">
                <input
                  id="r_trim"
                  v-model="opt"
                  class="form-check-input"
                  type="radio"
                  value="1"
                />
                <label class="form-check-label" for="r_trim">Trimestral</label>
              </div>

              <div class="form-check mb-0 mr-3" style="min-height: 0">
                <input
                  id="r_men"
                  v-model="opt"
                  class="form-check-input"
                  type="radio"
                  value="2"
                />
                <label class="form-check-label" for="r_men">Mensual</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center mt-2">
        <div class="col-md-12">
          <!-- Table-->
          <v-data-table
            :headers="headers"
            :items="filteredItems"
            :footer-props="footerProps"
            :options="dataTableOptions"
            :mobile-breakpoint="0"
            :loading="isLoading"
            class="elevation-2"
          >
            <template #header>
              <thead>
                <tr class="top-header">
                  <th colspan="4"></th>
                  <th class="text-center" :colspan="opt == 1 ? 6 : 13">
                    Facturados en el {{ opt == '1' ? 'Trimestre' : 'Mes' }}
                  </th>
                  <th class="text-center" style="width: 250px" colspan="2">
                    Variación
                  </th>
                  <th
                    v-if="opt == 1"
                    class="text-center"
                    style="width: 250px"
                    colspan="2"
                  >
                    Promedio Fact. Neta
                  </th>
                  <th
                    v-if="opt == 1"
                    class="text-center"
                    style="width: 250px"
                    colspan="2"
                    rowspan="2"
                  >
                    Descuentos <br />
                    actuales
                  </th>
                </tr>
                <tr v-if="opt == 1" class="top-header">
                  <th colspan="4"></th>
                  <th
                    v-for="(date, index) in [...itemsDates].reverse()"
                    :key="index"
                    colspan="2"
                    class="text-center"
                  >
                    {{ date }}
                  </th>
                  <th class="text-center" colspan="2">
                    {{ itemsDates[0] }} y {{ itemsDates[1] }}
                  </th>
                  <th class="text-center">{{ itemsDates[1] }}</th>
                  <th class="text-center">{{ itemsDates[0] }}</th>
                </tr>
              </thead>
            </template>

            <template #[`item.id`]="{ index }">
              {{ index + 1 }}
            </template>

            <template #[`item.NAME1`]="{ item }">
              <div class="text-left">
                <a
                  href="#"
                  class="customer--link"
                  @click.prevent="sendHomeView(item.KUNNR)"
                  ><b>{{ parseInt(item.KUNNR) }} {{ item.NAME1 }}</b></a
                >
              </div>
            </template>

            <template #[`item.status`]="{ item }">
              <div class="d-flex table-row">
                <template v-if="item.KUNBAJA == 0">
                  <v-tooltip top>
                    <template
                      v-if="item.isNewCustomer"
                      #activator="{ on, attrs }"
                    >
                      <v-icon v-bind="attrs" class="color3 mr-2" v-on="on">
                        mdi-account-plus
                      </v-icon>
                    </template>
                    <span>Cliente nuevo a 12 mes</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template
                      v-if="item.KUNNSA == 1"
                      #activator="{ on, attrs }"
                    >
                      <v-icon color="red" class="mr-2" v-bind="attrs" v-on="on">
                        mdi-cancel
                      </v-icon>
                    </template>
                    <span>Cliente bloqueado por crédito</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template
                      v-if="item.CGRUPO == 'P'"
                      #activator="{ on, attrs }"
                    >
                      <v-icon color="red" class="mr-2" v-bind="attrs" v-on="on">
                        mdi-account-group
                      </v-icon>
                    </template>
                    <span>Cliente de grupo</span>
                  </v-tooltip>

                  <svg-icon
                    v-if="item.VKBUR == 'IU25'"
                    name="hammer"
                    label="Cliente en jurídico"
                    size="30"
                  />
                </template>

                <v-tooltip top>
                  <template v-if="item.KUNBAJA == 1" #activator="{ on, attrs }">
                    <img
                      src="/img/angel.svg"
                      class="px-1"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <span>Cliente dado de baja</span>
                </v-tooltip>
              </div>
            </template>

            <template #[`item.BZIRK`]="{ item }">
              <span v-if="$route.meta.role === 'Seller'">{{ item.BZIRK }}</span>
              <span v-else class="text-truncate"
                >{{ item.DENOMZ }} ({{ item.BZIRK }})</span
              >
            </template>

            <!-- TOTREN -->
            <template v-for="n in numColums" #[`item.TOTREN${n}`]="{ item }">
              <span
                :key="n"
                :class="
                  getItemTextColorClass(
                    item[`TOTREN${n}`],
                    item,
                    numColums,
                    'TOTREN'
                  )
                "
              >
                {{ item[`TOTREN${n}`] | removeDecimals }}
              </span>
            </template>

            <!-- TOTFAC -->
            <template v-for="n in numColums" #[`item.TOTFAC${n}`]="{ item }">
              <span
                :key="n"
                :class="
                  getItemTextColorClass(
                    item[`TOTFAC${n}`],
                    item,
                    numColums,
                    'TOTREN'
                  )
                "
              >
                {{ opt === '1' ? '$' : ''
                }}{{ item[`TOTFAC${n}`] | removeDecimals }}
              </span>
            </template>

            <!-- Variation -->
            <template #[`item.difren1`]="{ item }">
              <span :class="{ 'text-danger': item.difren1 <= 0 }">{{
                item.difren1 | removeDecimals
              }}</span>
            </template>
            <template #[`item.difren2`]="{ item }">
              <span :class="{ 'text-danger': item.difren2 <= 0 }"
                >${{ item.difren2 | removeDecimals }}</span
              >
            </template>

            <!-- Average -->
            <template #[`item.prom1`]="{ item }">
              <span>${{ item.prom1 | removeDecimals }}</span>
            </template>
            <template #[`item.prom2`]="{ item }">
              <span>${{ item.prom2 | removeDecimals }}</span>
            </template>

            <!-- Discount -->
            <template #[`item.ZKRG`]="{ item }">
              <span>{{ item.ZKRG | removeDecimals }}%</span>
            </template>
            <template #[`item.ZKVL`]="{ item }">
              <span>{{ item.ZKVL | removeDecimals }}%</span>
            </template>
          </v-data-table>
          <!-- End Table -->
        </div>
      </div>

      <div class="py-5 text-left">
        <v-icon class="color3"> mdi-account-plus </v-icon>
        Clientes nuevos a 12 mes
      </div>

      <confidentiality-notice />
    </v-container>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import ConfidentialityNotice from '@/components/ConfidentialityNotice';
  import moment from 'moment';
  import axios from '@/plugins/axios';
  import service from '@/mixins/service';
  import userAuthOrStorage from '@/mixins/userAuthOrStorage';
  import highlightByValue from '@/mixins/highlightByValue';
  import SvgIcon from '@/components/icons/SvgIcon.vue';
  import IconTitle from '@/components/IconTitle.vue';
  export default {
    components: { ConfidentialityNotice, SvgIcon, IconTitle },
    mixins: [service, userAuthOrStorage, highlightByValue],
    data() {
      return {
        today: moment().format('YYYY/MM/DD'),
        defaultHeaders: [
          { text: 'N°', value: 'id', align: 'center' },
          { text: 'Zona', value: 'BZIRK', align: 'center' },
          {
            text: 'Cliente',
            value: 'NAME1',
            align: 'center',
            class: 'table--customer__min',
          },
          { text: 'iconos', value: 'status', align: 'left', sortable: false },
        ],
        items: [],
        itemCSV: [],
        dataTableOptions: {
          itemsPerPage: 24,
        },
        footerProps: {
          itemsPerPageOptions: [10, 14, 24, 34, { text: 'Todas', value: -1 }],
        },
        opt: null,
        isLoading: true,
        selectedZone: null,
        regionalManagersNames: null,
        selectedManagmentZone: null,
      };
    },
    computed: {
      ...mapGetters({
        authenticated: 'auth/authenticated',
        user: 'auth/user',
      }),
      itemsDates() {
        const now = moment();
        const limit = this.numColums;
        const currentMonth = now.format('M');

        return this.opt === '1'
          ? this.calcularUltimosTrim(limit, currentMonth).map(
              (quarter) => quarter.date
            )
          : this.calcularUltimosMeses(limit, currentMonth).map(
              (month) => month.date
            );
      },
      zoneSelect() {
        const allOption = { text: 'Todos', value: null };
        const options =
          this.$route.meta.role === 'Manager'
            ? this.items.map((item) => ({
                text: `${item.DENOMZ} (${item.BZIRK})`,
                value: item.BZIRK,
              }))
            : this.regionalManagersNames
            ? this.regionalManagersNames.map((regional) => ({
                text: `${regional.LOCCO} / ${regional.DENOMZ} / ${regional.NOMGER}`,
                value: regional.LOCCO,
              }))
            : [];
        return [allOption, ...options];
      },
      numColums() {
        return this.opt === '1' ? 3 : 13;
      },
      filteredBySelectedZone() {
        if (!this.selectedZone) return this.items;

        const text = this.selectedZone.toString().toLowerCase();
        return this.items.filter((item) =>
          item.BZIRK?.toString().toLowerCase().includes(text)
        );
      },
      filteredItems() {
        let items = this.filteredBySelectedZone;

        if (this.selectedManagmentZone) {
          items = items.filter(
            (item) => item.ZONA === this.selectedManagmentZone
          );
        }

        return items;
      },
      managmentZoneSelect() {
        const allOption = { text: 'Todos', value: null };
        const result = this.filteredBySelectedZone.map((item) => ({
          text: `Zona ${item.ZONA} (${item.BZIRK})`,
          value: item.ZONA,
        }));

        return [allOption, ...result];
      },
    },
    watch: {
      opt() {
        this.getRenglonajeCustomers();
        this.filteredHeaders();
        this.calculate();
      },
      items: {
        immediate: true,
        handler() {
          this.generarExcel();
        },
      },
      selectedZone() {
        this.selectedManagmentZone = null;
      },
    },
    mounted() {
      this.opt = '1';
      this.generarPDF();
      if (this.$route.meta.role === 'Regional') {
        this.getRegionalManagerNames();
      }
    },
    methods: {
      ...mapActions({
        sendToExcel: 'printer/sendToExcel',
        sendToPDF: 'printer/sendToPDF',
      }),
      async getRenglonajeCustomers() {
        try {
          this.isLoading = true;
          this.items = [];
          const role = this.$route.meta.role;
          const mapRole = {
            Manager: { code: this.validateManagerCode(), letter: 'G' },
            Seller: { code: this.validateSellerCode(), letter: 'A' },
            Regional: { code: this.validateRegionalManagerCode(), letter: 'T' },
          };

          let response = await axios.get('/renglonaje-by-customer', {
            params: {
              opc: parseInt(this.opt),
              P_VTWEG: this.user.VTWEG,
              employee_code: mapRole[role].code,
              P_OPCUSR: mapRole[role].letter,
            },
          });

          this.items = response.data.data;
          this.isLoading = false;
        } catch {
          this.$toast.error('Ocurrió un error al obtener a los clientes');
        }
      },
      async getRegionalManagerNames() {
        try {
          let response = await axios.get('structure/manager-regional', {
            params: {
              VTWEG: this.user.VTWEG,
              USERID: this.validateRegionalManagerCode(),
            },
          });
          this.regionalManagersNames = response.data.data;
        } catch {
          this.$toast.error('Ocurrió un error al obtener a los gerentes');
        }
      },
      calculate() {
        if (this.opt == '1') {
          const texts = ['Renglonaje', 'Fact. Neta'];
          for (let i = 4; i <= 11; i++) {
            this.headers[i].text = texts[(i - 4) % 2];
          }
          this.headers[12].text = this.itemsDates[2];
          this.headers[13].text = this.itemsDates[1];
          this.headers[14].text = texts[0];
          this.headers[15].text = 'Volumen';
        } else if (this.opt == '2') {
          for (let i = 0; i <= 12; i++) {
            this.headers[i + 4].text = this.itemsDates[12 - i];
          }
          this.headers[17].text = `${this.itemsDates[0]} y ${this.itemsDates[1]}`;
        }
      },
      generarPDF() {
        let objectCSV = {
          name: `renglonaje-${this.today}`,
          height: 1200,
          disabledClass: 'disabled-option',
        };

        this.sendToPDF(objectCSV);
      },
      generarExcel() {
        let newItems = [];
        this.itemCSV = [];

        for (let key in this.items) {
          let item = this.items[key];

          if (this.opt == 2) {
            newItems.push({
              ID: parseInt(key) + 1,
              ZONA: item.BZIRK,
              CLIENTE: item.NAME1,
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[4].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN6),
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[5].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN5),
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[6].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN4),
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[7].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN3),
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[8].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN2),
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[9].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN1),
              [`Var. Reng. ${this.headers[10].text}`]: item.DIFREN,
            });
          } else {
            newItems.push({
              ID: parseInt(key) + 1,
              ZONA: item.BZIRK,
              CLIENTE: item.NAME1,
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[4].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN4),
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[5].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN3),
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[6].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN2),
              [`Fact. ${this.opt == '1' ? 'Trim' : 'Mes'} ${
                this.headers[7].text
              }`]: this.$options.filters.formatCurrency(item.TOTREN1),
              [`Var. Reng. ${this.headers[8].text}`]: item.DIFREN,
              [`Var. Reng. ${this.headers[9].text}`]: item.DIFREN1,
              RENGLONAJE: item.ZKRG,
              VOLUMEN: item.ZKVL,
            });
          }
        }

        this.itemCSV = newItems;

        let objectCSV = {
          name: `renglonaje-${this.today}`,
          items: this.itemCSV,
          showLabels: true,
        };

        this.sendToExcel(objectCSV);
      },
      filteredHeaders() {
        this.headers = [];
        if (this.opt == 2) {
          this.headers = [
            ...this.defaultHeaders,
            { text: '', value: 'TOTREN13', align: 'center' },
            { text: '', value: 'TOTREN12', align: 'center' },
            { text: '', value: 'TOTREN11', align: 'center' },
            { text: '', value: 'TOTREN10', align: 'center' },
            { text: '', value: 'TOTREN9', align: 'center' },
            { text: '', value: 'TOTREN8', align: 'center' },
            { text: '', value: 'TOTREN7', align: 'center' },
            { text: '', value: 'TOTREN6', align: 'center' },
            { text: '', value: 'TOTREN5', align: 'center' },
            { text: '', value: 'TOTREN4', align: 'center' },
            { text: '', value: 'TOTREN3', align: 'center' },
            { text: '', value: 'TOTREN2', align: 'center' },
            { text: '', value: 'TOTREN1', align: 'center' },
            { text: '', value: 'DIFREN', align: 'center' },
          ];
        } else {
          this.headers = [
            ...this.defaultHeaders,
            { text: '', value: 'TOTREN3', align: 'center' },
            { text: '', value: 'TOTFAC3', align: 'center' },
            { text: '', value: 'TOTREN2', align: 'center' },
            { text: '', value: 'TOTFAC2', align: 'center' },
            { text: '', value: 'TOTREN1', align: 'center' },
            { text: '', value: 'TOTFAC1', align: 'center' },
            { text: '', value: 'difren1', align: 'center' },
            { text: '', value: 'difren2', align: 'center' },
            { text: '', value: 'prom2', align: 'center' },
            { text: '', value: 'prom1', align: 'center' },
            { text: '', value: 'ZKRG', align: 'center' },
            { text: '', value: 'ZKVL', align: 'center' },
          ];
        }
      },
      sendHomeView(code) {
        code = parseInt(code);
        this.$setLocalStorageCustomer(code);
        this.$router.push({ name: 'CustomerCoverDetails' });
      },
    },
  };
</script>

<style>
  .renglonaje-seller__container table thead tr {
    background: #f2f2f2 !important;
  }

  .renglonaje-seller__container table tbody {
    border-top: 3px solid rgb(112, 112, 112);
  }

  .renglonaje-seller__container table thead tr th {
    font-size: 14px !important;
    height: 30px !important;
    border-right: 1px solid #e0e0e0;
  }

  .renglonaje-seller__container .v-data-table-header__icon {
    opacity: 1 !important;
  }

  /* Aplica estilos a las filas pares */
  .renglonaje-seller__container .v-data-table tbody tr:nth-child(even) {
    background-color: #f5f5f5;
  }

  .renglonaje-seller__container .v-data-table tbody tr td {
    border-bottom: 0 !important;
    height: 30px !important;
    max-width: 400px !important;
  }

  .renglonaje-seller__container .top-header th {
    border-bottom: 0 !important;
  }

  .renglonaje-seller__container .options {
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
    opacity: 1;
    padding: 8px 20px;
    font-size: 14px;
    min-height: 30px;
  }

  .renglonaje-seller__container .options span {
    font-weight: bold;
  }

  .renglonaje-seller__container .color1 {
    color: #5600e8 !important;
  }
  .renglonaje-seller__container .color2 {
    color: #007bff !important;
  }
  .renglonaje-seller__container .color3 {
    color: #f600ff !important;
  }
  .renglonaje-seller__container .color4 {
    color: #dc091e !important;
  }
  .renglonaje-seller__container .color5 {
    color: #b71c1c !important;
  }

  .renglonaje-seller__container table .table--customer__min {
    min-width: 250px;
  }

  .renglonaje-seller__container table .customer--link {
    color: #000 !important;
  }
</style>
